<template>
  <div>
    <b-avatar size="32" :src="item.foto_jug" />
    <span class="font-weight-bolder">
      {{ item.apellido }} {{ item.nombre }}
    </span>
    <small class="notification-text">
      {{ item.categoria }} {{ item.equipo }}
    </small>
    <br />
    <span class="notification-text">
      Aplicar en etapa: {{ item.etapa_buscar }}
    </span>
    <b-button
      v-if="!showLoading"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      style="float:right"
      size="sm"
      @click="updateSancionPendiente(item)"
    >
      Actualizar
    </b-button>
    <b-button
      v-if="showLoading"
      variant="primary"
      disabled
      class="mr-1"
      size="sm"
      style="float:right"
    >
      <b-spinner small />
      <span class="sr-only">Loading...</span>
    </b-button>
    <span
      v-if="showError"
      style="font-size:10px; display:block; float:right; color:red"
      >No existen partidos para actualizar la sancion</span
    >
  </div>
</template>
<script>
import Ripple from 'vue-ripple-directive'
import { BButton, BAvatar, BSpinner } from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import { URL, USER } from '../../utils/variables'
import apiCall from '../../utils/apiCall'

export default {
  components: {
    BButton,
    BAvatar,
    BSpinner,
  },
  props: {
    item: Object,
  },
  directives: {
    Ripple,
  },
  setup(props, { emit }) {
    const showLoading = ref(false)
    const showError = ref(false)
    const { postApi } = apiCall()
    async function updateSancionPendiente() {
      // console.log(USER())
      // showLoading.value = true
      showLoading.value = true
      const dataSancion = {
        idEquipo: props.item.idEquipo,
        duracion: props.item.duracion,
        etapaBuscar: props.item.etapa_buscar,
        idSancion: props.item.id_sancion,
        idSancionPendiente: props.item.id_sancion_pendiente,
        idJugador: props.item.id_jugador,
        idAgrupacionPase: props.item.agrupacion_pase,
        idUser: USER().id_usuario,
        idCampeonato: props.item.id_campeonato,
        duracion_real: props.item.duracion_sancion,
      }
      const path = 'ApiSanciones/updateSancionPendiente'
      const data = await postApi(URL, path, dataSancion)
      if (data.flag === 'si') {
        // console.log(data.flag)
        emit('sancionExito', props.item)
        showError.value = false
      } else {
        showError.value = true
      }
      showLoading.value = false
    }
    return {
      updateSancionPendiente,
      showLoading,
      showError,
    }
  },
}
</script>
